<div
    (click)="open(item)"
    [ngClass]="{ 'api-email': item.contactEmail }"
    class="tCol clickCol pad"
    id="RowSelect1_{{ item.id }}"
>
    <div *ngIf="!item.contactEmail && !item.roleItem" class="initials desktop">{{ getInitials(item) }}</div>
    {{ item.roleItem ? item.roleName : item.email || item.contactEmail }}
</div>
